module.exports = __webpack_public_path__ + "img/99_1.00a7c13d.png";